






















import {Component, Prop, Vue} from 'vue-property-decorator'
import ThemesStore from '@/store/modules/ThemesStore'

@Component({
    components: {},
})
export default class Preview extends Vue {
    @Prop() private categories!: CMS.Category[];
    @Prop() private categoryItems!: CMS.CategoryItem[];
    @Prop() private cmsItems!: CMS.Item[];
    @Prop() private selections!: CMS.Selection[];
    @Prop() private condimentGroups!: CMS.CondimentGroup[];
    @Prop() private themeVariable!: CMS.ThemeVariable;
    @Prop() private themeCategoryVariables!: CMS.ThemeCategoryVariable[];
    @Prop() private themeItemVariables!: CMS.ThemeItemVariable[];
    @Prop() private deliousItems!: Delious.ItemDetailListResponse;

    @Prop() private pagePath!: string;

    @Prop() private isExpand!: boolean;

    @Prop() private resolution!: any;

    @Prop() private isCreated!: boolean;

    private iframe!: HTMLIFrameElement;

    get selectedThemeId(){
        return ThemesStore.selectedTheme.id;
    }

    get styleVariables() {
        return {
            'width': this.resolution.width + 'px',
            'height': this.resolution.height + 'px'
        };
    }

    mounted() {
        this.iframe = document.getElementById("screen") as HTMLIFrameElement;
        this.iframe.onload = () => this.$nextTick(() => this.update());

        this.$watch(() => this.categories, () => this.update(),{deep:true});
        this.$watch(() => this.categoryItems, () => this.update(),{deep:true});
        this.$watch(() => this.cmsItems, () => this.update(),{deep:true});
        this.$watch(() => this.selections, () => this.update(),{deep:true});
        this.$watch(() => this.condimentGroups, () => this.update(),{deep:true});
        this.$watch(() => this.themeVariable, () => this.update(),{deep:true});
        this.$watch(() => this.themeCategoryVariables, () => this.update(),{deep:true});
        this.$watch(() => this.themeItemVariables, () => this.update(),{deep:true});
        this.$watch(() => this.deliousItems, () => this.update(),{deep:true});

        this.$watch(() => this.pagePath, () => this.pageChange());

        this.$watch(() => this.isExpand, () => this.resizeIframe(),{deep:true});

        this.$watch(() => this.isCreated, () => this.update(),{deep:true});

        this.resizeIframe();
        window.addEventListener('resize', this.resizeIframeCallback);
    }

    destroyed() {
        window.removeEventListener('resize', this.resizeIframeCallback);
    }

    private update(): void {
        if (!this.isCreated) return ;
        
        const data = {
            api: {
                categories: this.categories,
                categoryItems: this.categoryItems,
                cmsItems: this.cmsItems,
                selections: this.selections,
                condimentGroups: this.condimentGroups,
                themeVariable: this.themeVariable,
                themeCategoryVariables: this.themeCategoryVariables,
                themeItemVariables: this.themeItemVariables,
                deliousItems: this.deliousItems
            }
        };

        (this.iframe as any).contentWindow.postMessage(data, '*');
    }

    private pageChange() {
        (this.iframe as any).contentWindow.postMessage({pagePath:this.pagePath}, '*');
    }

    private resizeIframeCallback = () => this.resizeIframe();

    private resizeIframe():void {
      let aspect = (<any>document).getElementById("aspectRatio").getBoundingClientRect();
      let scaleX = aspect.width / this.iframe.clientWidth;
      // let scaleY = aspect.height / this.iframe.clientHeight;

      this.iframe.style.transform = "scale3d("+ scaleX +", "+ scaleX +", 1)";
    }
}
